// extracted by mini-css-extract-plugin
module.exports = {"signupWrapper":"landingPage_signupWrapper__2iNCs","doodle":"landingPage_doodle__3nV9f","textCenter":"landingPage_textCenter__2aGyp"};